import { render, staticRenderFns } from "./otherDevice.vue?vue&type=template&id=328a1c22&scoped=true&"
import script from "./otherDevice.vue?vue&type=script&lang=js&"
export * from "./otherDevice.vue?vue&type=script&lang=js&"
import style0 from "./otherDevice.vue?vue&type=style&index=0&id=328a1c22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328a1c22",
  null
  
)

export default component.exports